<template>
  <div class="homePage">
    <div class="lable-box">
      <div
        :class="['lable', { active: active === 1 }]"
        @click="changeActive(1)"
      >
        {{ $t("common.task.recommendedSurveys") }}

        <span v-if="active == 1"></span>
      </div>
      <div
        :class="['lable', { active: active === 2 }]"
        @click="changeActive(2)"
      >
        {{ $t("common.task.topicDiscussion") }}
        <span v-if="active == 2"></span>
      </div>
    </div>

    <div class="task-list" v-if="active == 1">
      <div class="task-item" v-for="(item, index) in list" :key="index">
        <div class="task-item-top">
          <div class="name">{{ item.title }}</div>
          <div class="task-right">
            <div class="equipment">{{ $t("module.homepage.title10") }}:</div>
            <img
              v-if="item.deviceType === 2 || item.deviceType === 1"
              src="@/assets/image/homepage/pc.png"
            />
            <img
              v-if="item.deviceType === 1 || item.deviceType === 3"
              src="@/assets/image/homepage/phone.png"
            />
          </div>
        </div>
        <div class="task-item-content">
          <div class="star-box">
            <img
              v-for="cItem in Math.floor(item.IR / 20)"
              :key="cItem"
              src="@/assets/image/homepage/star.png"
            />
            <img
              v-for="cItem in 5 - Math.floor(item.IR / 20)"
              :key="cItem + Math.floor(item.IR / 20) + 1"
              src="@/assets/image/homepage/star-while.png"
            />
          </div>
          <div class="golds">
            {{ item.minPoints }}~{{ item.maxPoints
            }}<span>{{ $t("module.homepage.title11") }}</span>
          </div>
        </div>
        <div class="task-item-bottom">
          <div class="task-clock">
            <img class="clock" src="@/assets/image/homepage/clock.png" />
            <div>{{ item.LOI }}{{ $t("module.homepage.title12") }}</div>
          </div>
          <div class="task-text-box">
            <div
              class="show"
              v-if="item.allowedHide"
              @click="setIgnoreSurvey(item.id, index)"
            >
              {{ $t("module.homepage.title13") }}
            </div>
            <div
              class="many"
              @click="goUrl(`/module/taskDetails?id=${item.encryptId}`)"
            >
              {{
                item.multiple
                  ? $t("common.task.multipleCompletion")
                  : $t("common.task.participateNow")
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="empty-box" v-if="list.length === 0">
        <el-empty :description="$t('common.task.noData')"></el-empty>
      </div>
    </div>

    <div class="task-list" v-if="active == 2">
      <div class="task-item" v-for="(item, index) in list2" :key="index">
        <div class="task-item-top">
          <div class="name">{{ item.title }}</div>
          <div class="task-right">
            <div class="equipment">{{ $t("module.homepage.title10") }}:</div>
            <img
              v-if="item.deviceType === 2 || item.deviceType === 1"
              src="@/assets/image/homepage/pc.png"
            />
            <img
              v-if="item.deviceType === 1 || item.deviceType === 3"
              src="@/assets/image/homepage/phone.png"
            />
          </div>
        </div>
        <div class="task-item-content">
          <div class="star-box">
            <img
              v-for="cItem in Math.floor(item.IR / 20)"
              :key="cItem"
              src="@/assets/image/homepage/star.png"
            />
            <img
              v-for="cItem in 5 - Math.floor(item.IR / 20)"
              :key="cItem + Math.floor(item.IR / 20) + 1"
              src="@/assets/image/homepage/star-while.png"
            />
          </div>
          <div class="golds">
            {{ item.minPoints }}~{{ item.maxPoints
            }}<span>{{ $t("module.homepage.title11") }}</span>
          </div>
        </div>
        <div class="task-item-bottom">
          <div class="task-clock">
            <img class="clock" src="@/assets/image/homepage/clock.png" />
            <div>{{ item.LOI }}{{ $t("module.homepage.title12") }}</div>
          </div>
          <div class="task-text-box">
            <div
              class="show"
              v-if="item.allowedHide"
              @click="setIgnoreSurvey(item.id, index)"
            >
              {{ $t("module.homepage.title13") }}
            </div>
            <div class="many" @click="goUrl2(item.surveyLink)">
              {{
                item.multiple
                  ? $t("common.task.multipleCompletion")
                  : $t("common.task.participateNow")
              }}
            </div>
          </div>
        </div>
      </div>

      <div class="empty-box" v-if="list2.length === 0">
        <el-empty :description="$t('common.task.noData')"></el-empty>
      </div>
    </div>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import {
  getIndividualSurveys,
  setIgnoreSurvey,
  getForumSurveys,
} from "@/api/user";
export default {
  data() {
    return {
      menuTop: 86,
      percentage: 0,
      grade: 1,
      credit: 295,
      behindNumer: 800,
      active: 1,
      list: [],
      list2: [],
    };
  },
  components: { Navigation },
  methods: {
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },
    //获取任务列表
    getIndividualSurveys() {
      getIndividualSurveys().then((res) => {
        if (res.code === 200) {
          console.log("res", res);
          this.list = res.data.list;
        }
      });
    },

    getForumSurveys() {
      getForumSurveys().then((res) => {
        if (res.code === 200) {
          console.log("res", res);
          this.list2 = res.data.list;
        }
      });
    },

    //忽略
    setIgnoreSurvey(id, index) {
      this.$confirm(
        this.$t("common.task.hideConfirmMessage"),
        this.$t("common.task.hideConfirmTitle"),
        {
          confirmButtonText: this.$t("common.task.confirmButton"),
          cancelButtonText: this.$t("common.task.cancelButton"),
          type: "warning",
          confirmButtonClass: "confirmButtonText",
        }
      )
        .then(() => {
          setIgnoreSurvey({ id }).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t("common.task.hideSuccess"));
              this.list.splice(index, 1);
            }
          });
        })
        .catch(() => {});
    },
    goUrl(path) {
      const routeData = this.$router.resolve({
        path: path,
      });
      window.open(routeData.href, "_blank");
    },
    goUrl2(path) {
      window.open(path, "_blank");
    },
    changeActive(type) {
      this.active = type;
      localStorage.setItem("active", type);
    },
  },
  created() {
    this.getIndividualSurveys();
    this.getForumSurveys();
    if (localStorage.getItem("active")) {
      this.active = localStorage.getItem("active");
    }
  },
  mounted() {},
  destroyed() {},
};
</script>
<style scoped>
.circle >>> svg > path:nth-child(2) {
  stroke: url(#write);
}
.circle >>> .el-progress__text {
  display: none;
}
.progress >>> .el-progress-bar__inner {
  background: linear-gradient(90deg, #ffa200 0%, #ff6c00 100%);
}
</style>
<style lang="scss" scoped>
.homePage {
  height: auto;
  width: 100%;
  box-sizing: border-box;
  padding: 0 140px;
  .lable-box {
    width: 100%;
    height: 62px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-top: 32px;
    display: flex;
    padding: 0 33px;
    box-sizing: border-box;
    .lable {
      line-height: 62px;
      font-size: 18px;
      color: #474f66;
      font-weight: bolder;
      margin-right: 60px;
      position: relative;
      cursor: pointer;
      span {
        position: absolute;
        width: 16px;
        height: 4px;
        border-radius: 2px;
        background-color: #8948ff;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .active {
      color: #8948ff;
      font-size: 22px;
    }
  }
  .task-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 30px;
    .task-item {
      width: calc((100% - 32px) / 3);
      height: 186px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 16px;
      padding: 20px;
      box-sizing: border-box;
      margin-right: 16px;
      .task-item-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .name {
          font-size: 16px;
          font-weight: bolder;
          color: #232323;
        }
        .task-right {
          display: flex;
          align-items: center;
          .equipment {
            font-size: 12px;
            color: #999999;
            white-space: nowrap;
          }
          img {
            width: 16px;
            height: 16px;
            margin-left: 6px;
          }
        }
      }
      .task-item-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 48px;
        .star-box {
          display: flex;
          img {
            width: 15px;
            height: 16px;
          }
        }
        .golds {
          color: #8948ff;
          font-weight: bolder;
          font-size: 22px;
          span {
            font-size: 12px;
            color: #232323;
            font-weight: normal;
            margin-left: 10px;
          }
        }
      }
      .task-item-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 18px;
        .task-clock {
          color: #999999;
          font-size: 12px;
          display: flex;
          align-items: center;
          .clock {
            width: 14px;
            height: 14px;
            margin-right: 2px;
          }
        }
        .task-text-box {
          display: flex;
          align-items: center;
          .show {
            font-size: 14px;
            color: #474f66;
            margin-right: 28px;
            cursor: pointer;
          }
          .many {
            cursor: pointer;
            width: 104px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            color: #fff;
            background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
            box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
            border-radius: 16px 16px 16px 16px;
            font-size: 14px;
          }
        }
      }
    }
    .task-item:nth-child(3n) {
      margin-right: 0;
    }
  }
}

.empty-box {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */

@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    padding: 0 70px;
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .sign-box {
        flex-direction: column;
        .sign {
          width: 100%;
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    padding: 0 15px;
  }
}

@media only screen and (max-width: 900px) {
  .homePage {
    padding: 0 15px;
    .task-list {
      flex-direction: column;
      align-items: center;
      .task-item {
        width: 100%;
      }
    }
  }
}

@media only screen and (max-width: 700px) {
  .homePage {
    margin-top: 0;
    .lable-box {
      background-color: rgba(0, 0, 0, 0);
      padding: 0;
      margin-top: 0;
      .lable {
        margin-right: 31px;
        font-size: 16px;
      }
      .active {
        font-size: 22px;
      }
    }
    .task-list {
      margin-top: 20px;
    }
  }
}

@media only screen and (max-width: 660px) {
  .homePage {
    .task-list {
      flex-direction: column;
      align-items: center;
      // .task-item {
      //   margin-right: 0 !important;
      // }
    }
  }
}
</style>